import { InfoCircleFilled } from "@ant-design/icons"
import { Radio, Space, Tooltip } from "antd"
import { useEffect, useState } from "react"
import { getThemedImage, getTranslated, isHTMLString } from "../../utils/CommonUtils"
import { applyROAccess } from "../../utils/ValidationUtils"
import parse from 'html-react-parser'
import { useSelector } from "react-redux"

/**
 * @param {*} props 
 * @param {Array[Object]} props.options array of objects as label-value pair
 * @example props.options => [{
        label: Private network,
        value: private_nw,
        help: Private Network, // Info icon will be shown iff info attribute exist and it'll be shown as tooltip on hovering of Info icon
        }, 
        ...
    ]
    @param {String} props.value Selected item value
    @param {function} props.handleChange to handle the radio button selection
    @param {String} props.direction to display radio buttons vertically or horizontally
    @returns {React.ReactNode} returns a reactNode to display a radio button group
 */

const RadioButton = (props) => {

    const [value, setValue] = useState(null)
    const [options, setOptions] = useState([])
    const [readOnly, setReadOnly] = useState(false)
    const dict = useSelector(state => state.common.dict)

    useEffect(() => {

        if (value === null && props.value === undefined) {
            setValue(props.defaultValue)
            props.handleSchemaDataChange && props.handleSchemaDataChange(props, props.defaultValue)
        } else {
            setValue(props.value)
        }

        let options = []
        if (props.options?.length || props.enum?.length)
            options = props.options || props.enum
        else
            options = [{
                label: props.label,
                value: props.value
            }]

        setOptions(options)
    }, [props.value, props.options, props.label, props.defaultValue, props.enum])

    useEffect(() => {
        setReadOnly(props.isReadOnly || applyROAccess(props.access, props.actionMode))
    }, [props.access, props.actionMode, props.isReadOnly])

    const onChange = (e) => {
        setValue(e.target.value)
        props.handleChange && props.handleChange(e.target.value)
        props.handleSchemaDataChange && props.handleSchemaDataChange(props, e.target.value)
    }

    return <div style={{}} className={props.parentClassName}>
        <Radio.Group
            onChange={onChange}
            value={value}
            buttonStyle="solid"
            className={props.className}
            disabled={props.disabled || readOnly}
        >
            <Space direction={props.direction || "vertical"}>
                {options?.map(eData => <Radio
                    value={eData.value}
                    key={eData.value}
                    disabled={eData.disabled}>
                    <div className="radio-btn-label">
                        {(eData.icon || props.icon) ? <div className="radio-opt-icon">
                            <img src={getThemedImage(eData.icon || props.icon)} style={{ height: props.id === "personalized" ? "1.5em" : "" }} alt="" />
                        </div> : <></>}
                        <>
                            {eData.value === value ? <b>{getTranslated(dict, eData.label)}</b> : getTranslated(dict, eData.label)}
                            {(eData.help || props.help) ?
                                <Tooltip title={isHTMLString(getTranslated(dict, eData.help || props.help)) ? parse(getTranslated(dict, eData.help || props.help)) : getTranslated(dict, eData.help || props.help)} overlayInnerStyle={{ width: props.tooltipWidth }}>
                                    <InfoCircleFilled className="radio-info-icon" role="icon" aria-label={eData.value} />
                                </Tooltip>
                                : <></>}
                        </>

                    </div>
                </Radio>)}
            </Space>
        </Radio.Group>
    </div>
}

export default RadioButton